<script setup lang="ts">
defineProps<{
  label?: string
  message?: string
  status?: 'error' | 'success' | string
}>()
</script>

<template>
  <div
    class="log"
    :class="{ 'auth-field--error': status === 'error' }"
  >
    <span v-if="label" class="label">{{ label }}</span>
    <slot />
    <span
      v-if="message"
      class="trouble-comment block mt-1 w-full text-left"
      :class="status === 'error' || message ? 'trans-visible' : 'trans-hidden'"
    >
      {{ message }}
    </span>
  </div>
</template>
